import React, {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useContext,
} from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import config from "../../config/config";
import { toastError } from "../../common/Toast";
import { Noimage } from "../../common/imagePath";
import loadingimageIcon from "../../assets/img/loading-svg.svg";
import { AppContext } from "../../context/AppContext";

function CommonItemSearch({
  customerID = 0,
  supplierID = 0,
  callback,
  disabled,
  readonly,
  value,
  callbackaccount,
  searchItemInputRef,
}) {
  const searchResultRef = useRef(null);
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loadingImage, setLoadingImage] = useState(false);
  const {enableRecallPrice} = useContext(AppContext)
  console.log(value, suggestions, "suggestions");
  
  console.log(enableRecallPrice, "enableRecallPrice");

  const [cursor, setcursor] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputValue) {
        fetchData();
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  // Click outside to hide search results
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchResultRef.current &&
        !searchResultRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchResultRef]);

  // Fetch data from an API
  const fetchData = async () => {
    setcursor(0);
    setSuggestions([])
    if (inputValue != "") {
      setLoadingImage(true);
      if (value != 4) {
        let itemsearchtype = "";
        if (value == 1) {
          itemsearchtype = "sale";
        }
        await axios
          .get(
            `${
              config.itemsBaseUrl
            }/items/searchforaccount?searchparam=${encodeURIComponent(
              inputValue.trim()
            )}&iscategory=${0}&customerid=${customerID}&supplierid=${supplierID}&locationid=${locationID}&itemsearchtype=${itemsearchtype}&isservice=${1}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response.data.ResponseData.length > 0) {
              console.log(response.data.ResponseData, "checkData 1");
              if (response != "" && response != null) {
                const data = response.data.ResponseData;

                console.log(data, "checkData 2");

                const itemarray = data[0].Itemnumber.split(",");
                console.log(itemarray, "checkData 3");
                if (data.length === 1 && itemarray.includes(inputValue)) {
                  console.log(data, "checkData 5");
                  handleInputClick(data);
                  //   handleInputClick(
                  //     data[0].ItemId,
                  //     data[0].ItemName,
                  //     data[0].VariationName,
                  //     data[0].UnitPrice,
                  //     data[0].Itemquantity,
                  //     data[0].Description,
                  //     data[0].VariationId,
                  //     data[0].AttributeId,
                  //     data[0].Module,
                  //     data[0].CategoryID,
                  //     data[0].CategoryName,
                  //     data[0].CostPrice,
                  //     data[0].Itemnumber,
                  //     data[0].Allowaltdescription,
                  //     data[0].IsItemserialnumber,
                  //     data[0].VariationQuantity,
                  //     data[0].RecallPrice,
                  //     data[0].Tier1,
                  //     data[0].Tier2,
                  //     data[0].Tier3,
                  //     data[0].Tier4,
                  //     data[0].Tier5,
                  //     data[0].QuickbookId,
                  //     data[0]?.isReCallPrice,
                  //     data[0]?.Tax1,
                  //     data[0]?.Tax2,
                  //     data[0]?.Tax3,
                  //     data[0]?.Tax4,
                  //     data[0]?.Tax5,
                  //     data[0]?.TaxName1,
                  //     data[0]?.TaxName2,
                  //     data[0]?.TaxName3,
                  //     data[0]?.TaxName4,
                  //     data[0]?.TaxName5,
                  //     data[0]?.TaxVal1,
                  //     data[0]?.TaxVal2,
                  //     data[0]?.TaxVal3,
                  //     data[0]?.TaxVal4,
                  //     data[0]?.TaxVal5,
                  //     data[0]?.Isdefault,
                  //     data[0]?.Cummalative,
                  //     data[0]?.taxes
                  //   );
                  // setTableData([...tableData,...data])
                } else {
                  console.log(data, "checkData 5");
                  setSuggestions(data);
                  setLoadingImage(false);
                }
              }
            } else {
              toastError("No Item Found");
              setLoadingImage(false);
            }
          })
          .catch((error) => {});
      } else {
        let itemsearchtype = "vendorcredit";

        await axios
          .get(
            `${
              config.itemsBaseUrl
            }/items/searchforaccount?searchparam=${encodeURIComponent(
              inputValue
            )}&iscategory=${1}&customerid=${customerID}&supplierid=${supplierID}&locationid=${locationID}&itemsearchtype=${itemsearchtype}&isservice=${0}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response.data.ResponseData.length > 0) {
              if (response != "" && response != null) {
                const data = response.data.ResponseData;
                // const itemarray = data[0].Itemnumber.split(",");

                // if (data.length === 1 && itemarray.includes(inputValue)) {
                //   handleInputClick(data);
                //   //   handleInputClick( data[0]
                //   // data[0].ItemId,
                //   // data[0].ItemName,
                //   // data[0].VariationName,
                //   // data[0].UnitPrice,
                //   // data[0].Itemquantity,
                //   // data[0].Description,
                //   // data[0].VariationId,
                //   // data[0].AttributeId,
                //   // data[0].Module,
                //   // data[0].CategoryID,
                //   // data[0].CategoryName,
                //   // data[0].CostPrice,
                //   // data[0].Itemnumber,
                //   // data[0].Allowaltdescription,
                //   // data[0].IsItemserialnumber,
                //   // data[0].VariationQuantity,
                //   // data[0].RecallPrice,
                //   // data[0].Tier1,
                //   // data[0].Tier2,
                //   // data[0].Tier3,
                //   // data[0].Tier4,
                //   // data[0].Tier5,
                //   // data[0].QuickbookId,
                //   // data[0].isReCallPrice,
                //   // data[0]?.Tax1,
                //   // data[0]?.Tax2,
                //   // data[0]?.Tax3,
                //   // data[0]?.Tax4,
                //   // data[0]?.Tax5,
                //   // data[0]?.TaxName1,
                //   // data[0]?.TaxName2,
                //   // data[0]?.TaxName3,
                //   // data[0]?.TaxName4,
                //   // data[0]?.TaxName5,
                //   // data[0]?.TaxVal1,
                //   // data[0]?.TaxVal2,
                //   // data[0]?.TaxVal3,
                //   // data[0]?.TaxVal4,
                //   // data[0]?.TaxVal5,
                //   // data[0]?.Isdefault,
                //   // data[0]?.Cummalative,
                //   // data[0]?.taxes
                //   //   );

                //   // setTableData([...tableData,...data])
                // } else {
                  setSuggestions(data);
                  setLoadingImage(false);
                // }
              }
            }else{
              toastError("No Account Found");
              setLoadingImage(false);
            }
          })
          .catch((error) => {});
      }
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  const handleToast = () => {
    if (readonly === true) {
      toastError("Please Select a Customer First");
    }
  };

  const handleInputClick = (data) => {
    setTableData(data);
    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    if (locationItemData?.length > 0) {
      if (value == 4) {
        callbackaccount(locationItemData);
      } else {
        callback(locationItemData);
      }
    }
  }, [tableData]);

  // const handleKeyDown = (e) => {

  //   console.log(e?.key, "keypresscheck");

  //   if (e.keyCode === 13 || e.key === "Enter") {
  //    if(suggestions?.length === 0){
  //       return
  //     }
  //     const item = suggestions[cursor];
  //     handleInputClick(
  //       [item]
  //       // item.ItemId,
  //       // item.ItemName,
  //       // item.VariationName,
  //       // item.UnitPrice,
  //       // item.Itemquantity,
  //       // item.Description,
  //       // item.VariationId,
  //       // item.AttributeId,
  //       // item.Module,
  //       // item.CategoryID,
  //       // item.CategoryName,
  //       // item.CostPrice,
  //       // item.Itemnumber,
  //       // item.Allowaltdescription,
  //       // item.IsItemserialnumber,
  //       // item.VariationQuantity,
  //       // item.RecallPrice,
  //       // item.Tier1,
  //       // item.Tier2,
  //       // item.Tier3,
  //       // item.Tier4,
  //       // item.Tier5,
  //       // item.QuickbookId,
  //       // item?.isReCallPrice,
  //       // item?.Tax1,
  //       // item?.Tax2,
  //       // item?.Tax3,
  //       // item?.Tax4,
  //       // item?.Tax5,
  //       // item?.TaxName1,
  //       // item?.TaxName2,
  //       // item?.TaxName3,
  //       // item?.TaxName4,
  //       // item?.TaxName5,
  //       // item?.TaxVal1,
  //       // item?.TaxVal2,
  //       // item?.TaxVal3,
  //       // item?.TaxVal4,
  //       // item?.TaxVal5,
  //       // item?.Isdefault,
  //       // item?.Cummalative,
  //       // item.taxes
  //     );
  //   } else if (e.keyCode === 38 && cursor > 0) {
  //     setcursor(cursor - 1);
  //   } else if (e.keyCode === 40 && cursor < suggestions.length - 1) {
  //     setcursor(cursor + 1);
  //   }
  // };

  const handleKeyDown = (e) => {
    console.log(e.key, cursor, "256348");

    if (!suggestions || suggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      setcursor((prev) => (prev + 1) % suggestions.length);
    } else if (e.key === "ArrowUp") {
      setcursor((prev) => (prev - 1 + suggestions.length) % suggestions.length);
    } else if (e.key === "Enter") {
      const item = suggestions[cursor];
      handleInputClick([item]);
    }
  };

  
  const handelItemNavigate = ()=>{
    window.open('/manage-items', '_blank')
  }
  
  console.log(cursor, "cursor");

  return (
    <div className="">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <div onClick={handelItemNavigate} >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </div>
            </span>
            <div
              style={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <input
                ref={searchItemInputRef}
                type="text"
                className="form-control form-control-sm border-size-input"
                placeholder={
                  value == 4
                    ? "Select Category"
                    : "Type item name or scan barcode"
                }
                value={inputValue}
                onChange={handleInputChange}
                onClick={handleToast}
                disabled={disabled}
                readOnly={readonly}
                onKeyDown={handleKeyDown}
                style={{
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                }}
              />
              {loadingImage && (
                <div
                  style={{ position: "absolute", right: "5px", top: "10px" }}
                >
                  <img
                    src={loadingimageIcon}
                    alt="Loading..."
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {suggestions?.length > 0 ? (
          <>
            <div ref={searchResultRef} className="dropdown">
              <ul
                className="dropdown-menu show dropdown-suggestion"
                style={{ overflow: "auto", width: "120% ", maxWidth: "600px" }}
              >
                {suggestions?.map((item, index) => (
                  <li
                    // className="border-bottom"
                    className={
                      cursor === index
                        ? "border-bottom active"
                        : "border-bottom"
                    }
                    key={item.ItemId}
                    onClick={() =>
                      handleInputClick(
                        [item]
                        // item.ItemId,
                        // item.ItemName,
                        // item.VariationName,
                        // item.UnitPrice,
                        // item.Itemquantity,
                        // item.Description,
                        // item.VariationId,
                        // item.AttributeId,
                        // item.Module,
                        // item.CategoryID,
                        // item.CategoryName,
                        // item.CostPrice,
                        // item.Itemnumber,
                        // item.Allowaltdescription,
                        // item.IsItemserialnumber,
                        // item.VariationQuantity,
                        // item.RecallPrice,
                        // item.Tier1,
                        // item.Tier2,
                        // item.Tier3,
                        // item.Tier4,
                        // item.Tier5,
                        // item.QuickbookId,
                        // item.isReCallPrice,
                        // item?.Tax1,
                        // item?.Tax2,
                        // item?.Tax3,
                        // item?.Tax4,
                        // item?.Tax5,
                        // item?.TaxName1,
                        // item?.TaxName2,
                        // item?.TaxName3,
                        // item?.TaxName4,
                        // item?.TaxName5,
                        // item?.TaxVal1,
                        // item?.TaxVal2,
                        // item?.TaxVal3,
                        // item?.TaxVal4,
                        // item?.TaxVal5,
                        // item?.Isdefault,
                        // item?.Cummalative,
                        // item?.taxes
                      )
                    }
                  >
                    {value == 4 && (
                      <Link
                        key={item.ItemId}
                        href="#"
                        className={
                          cursor === index
                            ? "dropdown-item active" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                            : "dropdown-item" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                        }
                        data-name={item.ItemName?.toLowerCase()}
                      >
                        <img
                          src={item.ImageName || Noimage}
                          onError={(e) => {
                            e.currentTarget.src = Noimage;
                          }}
                          alt={item.ItemName}
                          className="img-thumbnail rounded-circle m-2"
                          width="55"
                          height="55"
                        />
                        <div className="customer-info">
                          <strong className="name word-break-data">
                            {item.ItemName}{" "}
                            {item.VariationName
                              ? `(${item.VariationName})`
                              : ""}
                          </strong>

                          <div>Account Type: {item.AccountTypeName}</div>
                          <div>{item.AccountDeatilsTypeName}</div>
                          {/* Add any other customer details here */}
                        </div>
                      </Link>
                    )}

                    {value != 4 && (
                      <Link
                        key={item.ItemId}
                        href="#"
                        className={
                          cursor === index
                            ? "dropdown-item active" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                            : "dropdown-item" +
                              (item.QuickbookId > 0 ? " bg-green" : "")
                        }
                        data-name={item.ItemName?.toLowerCase()}
                      >
                        <img
                          src={item.ImageName || Noimage}
                          onError={(e) => {
                            e.currentTarget.src = Noimage;
                          }}
                          alt={item.ItemName}
                          className="img-thumbnail rounded-circle m-2"
                          width="55"
                          height="55"
                          style={{ height: "60px", objectFit: "contain" }}
                        />
                        <div className="customer-info w-100">
                          <strong className="name word-break-data">
                            {item.ItemName}{" "}
                            {item.VariationName
                              ? `(${item.VariationName})`
                              : ""}
                          </strong>
                          
                          <div>
                            {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                           Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}| */}
                            {/* Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}

                            {customerID > 0 ? (
                              <>
                                Selling Price:{" "}
                                {parseFloat(item.Price).toFixed(2)}
                                {enableRecallPrice && (
                                  <>
                                    | Recall Price:{" "}
                                    {parseFloat(item.RecallPrice).toFixed(2)}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                Cost Price:{" "}
                                {parseFloat(item.CostPrice).toFixed(2)}
                              </>
                            )}{" "}
                            {" "}| Qty:{" "}
                            {parseInt(
                              item.Itemquantity ? item.Itemquantity : 0
                            )}
                          </div>
                          <div>Categories: {item.CategoryName}</div>
                          <div style={{ display: "flex", float: "right" }}>
                            {item.QuickbookId > 0 && (
                              <span>
                                <i
                                  className="fa fa-circle"
                                  style={{ fontSize: "14px", color: "green" }}
                                ></i>{" "}
                                QB Sync
                              </span>
                            )}
                          </div>
                          {/* Add any other customer details here */}
                        </div>
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : null}
      </form>
    </div>
  );
}

export default CommonItemSearch;
